import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '../Typography.component';

// Options for type prop: icon, ordered, unordered
// <List label="Label" items={['Item 1', 'Item 2', <>Item 3 <Component /></>]} type="icon" icon="affirm" />
// For items with children use fragments <></>
// TODO: Add tooltip to the list header

const List = ({ label, items, type = 'unordered', icon, tooltip }) => {
	if (!items?.length) {
		return null;
	}

	return (
		<div className="common-ui-list">
			{(label || tooltip) && (
				<div className="list-header">
					{label && <h2 className="label">{label}</h2>}
					{tooltip && <span className="tooltip">{tooltip}</span>}
				</div>
			)}
			<ul className={classNames('list', type)}>
				{items.map((item, index) => (
					<li key={index} className={classNames('item', icon)}>
						<Typography.P>{item}</Typography.P>
					</li>
				))}
			</ul>
		</div>
	);
};

List.propTypes = {
	label: PropTypes.string,
	items: PropTypes.arrayOf(PropTypes.node).isRequired,
	type: PropTypes.oneOf(['icon', 'unordered']),
	icon: PropTypes.oneOf(['affirm']), // add to these as needed
	tooltip: PropTypes.string,
};

export default List;
